var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommuteSeparator(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 126,
    viewBox: "0 0 114 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M4.59277 1C6.11767 9.86328 8.92627 16.6284 11.1362 21.0435C15.8716 30.5078 20.874 35.1606 22.7354 36.7856C26.5435 40.1147 29.8892 43.0366 32.9258 42.2539C37.3096 41.1289 39.8257 32.6123 39.3398 21.3042C28.6475 -1.46484 -6.03418 68.9561 22.9771 77.1689C33.042 81.1953 44.9634 79.2837 46.7622 68.623C47.0566 58.2622 44.4624 52.916 40.6191 51.0669C33.7461 47.7695 11.6929 76.3384 22.5366 94.5186C29.8564 106.803 49.731 111.472 60.3291 103.855C63.5606 101.532 77.7925 81.7769 74.9829 77.0815C72.5615 73.0293 66.169 71.9927 61.627 73.3564C53.5918 75.7729 50.3965 86.0024 50.0835 92.1655C49.4453 104.859 59.1211 118.288 71.2354 121.165C86.1953 124.719 105.35 112.307 109.396 90.2969",
    stroke: "#808080",
    strokeWidth: 8.10285,
    strokeMiterlimit: 5.71702
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommuteSeparator);
export default __webpack_public_path__ + "static/media/commute-separator.f19dda7e29dbd8f8fb7c17549ccf26d7.svg";
export { ForwardRef as ReactComponent };